var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"columns":_vm.columns,"rows":_vm.partnerOrdersSorted,"row-style-class":function (row) { return _vm.getRowStyleClass(row); },"sort-options":{
      initialSortBy: { field: 'created_at', type: 'desc' },
    }},on:{"on-row-click":_vm.onRowClick,"on-sort-change":_vm.onSortChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }